import React from 'react';
// components
import { modalStyles } from '../modal/ui';
// ui
import { Box } from '../../ui';
//////////////////////////////////////////////////

export const ResizeHandleComponent = () => (
  <Box width='5px' height='100%' bg={modalStyles.frameBgColor} backdropFilter={modalStyles.frameBlur} />
);

export const getInitialOptions = (isResizable) => ({
  minWidth: 370,
  minHeight: 400,
  maxWidth: '94vw',
  maxHeight: '100%',
  disableDragging: true,
  enableResizing: { left: true },
  style: { pointerEvents: 'auto', cursor: null },
  default: { x: 0, y: 0, width: '40vw', height: '100%' },
  resizeHandleStyles: {
    left: { cursor: 'ew-resize' },
  },
  resizeHandleComponent: {
    left: isResizable && <ResizeHandleComponent />,
  },
});

export const initialWrapperStyles = {
  top: '0px',
  zIndex: 20,
  right: '0px',
  width: '40vw',
  height: '100vh',
  position: 'fixed',
  disableEvents: true,
};
